import React, { useEffect } from 'react'
import { MDX, Image } from 'components/contentbricks'
// import Lottie from 'react-lottie'

require('./styles.scss')

interface Props {
  title?: string
  text?: string
  image?: string
  time?: string
  cssClass?: string
}

export const LifeStep = ({
  title,
  text = '',
  time = '',
  image,
  cssClass = ''
}: Props) => {
  // useEffect(() => {
  //   const svgs = document.getElementsByTagName('svg')
  //   for (var i = 0; i < svgs.length; i++) {
  //     const elem = svgs[i].parentElement || svgs[i]
  //     if (elem !== undefined) {
  //       elem.addEventListener('click', e => {
  //         e.stopPropagation()
  //       })
  //     }
  //   }
  // }, [])

  var animationData
  if (image && image.indexOf('json') !== -1)
    animationData = require('../../animations/' + image)
  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: 'svg',
    rendererSettings: {
      className: 'lottiesvg'
    }
  }
  return (
    <div className={'ui container ' + cssClass} id='lifestep'>
      <div className='ui stackable grid'>
        <div className='ui eight wide column imageHolder'>
          {image && image.indexOf('json') === -1 && (
            <>
              <div className='time'>
                <div className='timeText'>{time}</div>
              </div>
              {/* <div className='time'><Image file='timebg.svg'/><div className='timeText'>{time}</div></div> */}
              <Image file={image} />
            </>
          )}
          {image && image.indexOf('json') !== -1 && (
            <>
              {/* <Lottie
                options={lottieOptions}
                style={{ width: '90%', height: 'auto', marginTop: '-64px' }}
              /> */}
              <div className='time'>
                {time}
                <img src='images/timebg.svg' />
              </div>
            </>
          )}
        </div>
        <div className='ui eight wide column'>
          <div className='lifetext vertCenter'>
            {title && <h4 className='title'>{title}</h4>}
            <MDX file={text} />
          </div>
        </div>
      </div>
    </div>
  )
}
